export default class TabList {
	constructor(node) {
		if (!node) {
			return;
		}

		this.node = node;

		for (const navItem of this.node.querySelectorAll('[data-tab-target]')) {
			navItem.addEventListener('click', (event) => {
				if (event.target.dataset.tabTarget) {
					this.openTab(event.target.dataset.tabTarget);
				}
			});
		}
	}

	openTab(tabId) {
		// iterate tab navigation items
		for (const navItem of this.node.querySelectorAll('[data-tab-target]')) {
			if (navItem.dataset.tabTarget === tabId) {
				navItem.classList.add('active');
			} else {
				navItem.classList.remove('active');
			}
		}

		// iterate tab panels
		for (const tab of this.node.querySelectorAll('[data-tab]')) {
			if (tab.dataset.tab === tabId) {
				tab.classList.add('active');
			} else {
				tab.classList.remove('active');
			}
		}
	}
};
